"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _formik = require("formik");

var _index = require("../index");

var _index2 = require("./index.styles");

var _Input = _interopRequireDefault(require("./Input"));

var _excluded = ["children", "label"],
    _excluded2 = ["children"];

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var RadioGroup = function RadioGroup(_ref) {
  var children = _ref.children,
      label = _ref.label,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_index.Label, props, label), children);
};

RadioGroup.propTypes = {
  children: _propTypes.node.isRequired,
  label: _propTypes.string.isRequired
};
RadioGroup.defaultProps = {
  disabled: false
};

var Radio = function Radio(_ref2) {
  var children = _ref2.children,
      props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);

  var _useField = (0, _formik.useField)(_objectSpread(_objectSpread({}, props), {}, {
    type: 'radio'
  })),
      _useField2 = (0, _slicedToArray2["default"])(_useField, 1),
      field = _useField2[0];

  var disabled = props.disabled;
  return /*#__PURE__*/_react["default"].createElement(_index2.StyledLabel, {
    disabled: disabled ? true : undefined
  }, /*#__PURE__*/_react["default"].createElement(_formik.Field, (0, _extends2["default"])({
    type: "radio",
    as: _Input["default"]
  }, field, props)), children);
};

Radio.Group = RadioGroup;
Radio.propTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
    type: (0, _propTypes.oneOf)([_index.FieldLabel])
  })]).isRequired,
  value: _propTypes.string.isRequired,
  disabled: _propTypes.bool
};
Radio.defaultProps = {
  disabled: false
};
var _default = Radio;
exports["default"] = _default;